import type { AxiosResponse } from "axios";

const headerValue = (
  headers: Record<string, unknown> | undefined,
  name: string,
): string | undefined => {
  if (!headers) return undefined;
  const lower = name.toLowerCase();
  for (const key of Object.keys(headers)) {
    if (key.toLowerCase() === lower) {
      const value = headers[key];
      return typeof value === "string" ? value : undefined;
    }
  }
  return undefined;
};

export const isRestTokenExpired = (
  response: AxiosResponse | undefined,
): boolean => {
  const wwwAuthenticate = headerValue(
    response?.headers as Record<string, unknown> | undefined,
    "www-authenticate",
  );
  if (!wwwAuthenticate) return false;
  return (
    /invalid_token/i.test(wwwAuthenticate) ||
    /token expired/i.test(wwwAuthenticate)
  );
};

export const isGraphQLAuthError = (error: unknown): boolean => {
  const err = error as {
    response?: { errors?: unknown };
    errors?: unknown;
  };
  const errors = err?.response?.errors ?? err?.errors;
  if (!Array.isArray(errors)) return false;
  return errors.some((entry) => {
    const item = entry as {
      message?: unknown;
      extensions?: { code?: unknown };
    };
    return (
      item?.extensions?.code === "AUTH_NOT_AUTHENTICATED" ||
      item?.message === "User is not authenticated."
    );
  });
};

export const isAiTokenExpired = (data: unknown): boolean => {
  const body = data as { detail?: unknown };
  return body?.detail === "Token expired";
};

export const isRefreshTokenExpired = (error: unknown): boolean => {
  const status = (error as { response?: { status?: number } })?.response
    ?.status;
  return status === 401;
};
